import { schema } from 'normalizr'

// Circular Dependencies - Use the define method
// const item = new schema.Entity('item')
// const child = new schema.Entity('child')
// item.define({ children: [child] })

// Define Entities
const asset = new schema.Entity('assets')
const job = new schema.Entity('jobs')
const merchandise = new schema.Entity('merchandises')
const office = new schema.Entity('offices')
const order = new schema.Entity('orders')
const orderItem = new schema.Entity(
  'orderItems',
  {},
  {
    processStrategy: (value, parent) => {
      if (parent && parent.status) {
        return { ...value, order_status: parent.status }
      }
      return value
    },
  }
)
const partFile = new schema.Entity('partFiles')
const post = new schema.Entity('posts')
const project = new schema.Entity('projects')
const projectFile = new schema.Entity('projectFiles')
const task = new schema.Entity('tasks')
const taskSheet = new schema.Entity('taskSheets')
const user = new schema.Entity('users')

order.define({
  items: [orderItem],
})

// SQL
const sqlAsset = new schema.Entity('sqlAssets')
const sqlServiceJob = new schema.Entity('sqlServiceJobs')

// enums
const merchandiseGroup = new schema.Entity(
  'merchandiseGroups',
  {},
  {
    idAttribute: (value) => value.value,
  }
)

const partType = new schema.Entity(
  'partTypes',
  {},
  {
    idAttribute: (value) => value.value,
  }
)

const partSubType = new schema.Entity(
  'partSubTypes',
  {},
  {
    idAttribute: (value) => value.value,
  }
)

const serviceType = new schema.Entity(
  'serviceTypes',
  {},
  {
    idAttribute: (value) => value.value,
  }
)

const userRole = new schema.Entity(
  'userRoles',
  {},
  {
    idAttribute: (value) => value.value,
  }
)

// Export Schemas
export const Schemas = {
  ASSET: asset,
  ASSET_ARRAY: [asset],
  JOB: job,
  JOB_ARRAY: [job],
  MERCHANDISE: merchandise,
  MERCHANDISE_ARRAY: [merchandise],
  OFFICE: office,
  OFFICE_ARRAY: [office],
  ORDER: order,
  ORDER_ARRAY: [order],
  ORDER_ITEM: orderItem,
  ORDER_ITEM_ARRAY: [orderItem],
  PART_FILE: partFile,
  PART_FILE_ARRAY: [partFile],
  POST: post,
  POST_ARRAY: [post],
  PROJECT: project,
  PROJECT_ARRAY: [project],
  PROJECT_FILE: projectFile,
  PROJECT_FILE_ARRAY: [projectFile],
  TASK: task,
  TASK_ARRAY: [task],
  TASK_SHEET: taskSheet,
  TASK_SHEET_ARRAY: [taskSheet],
  USER: user,
  USER_ARRAY: [user],
  // SQL
  SQL_ASSET: sqlAsset,
  SQL_ASSET_ARRAY: [sqlAsset],
  SQL_SERVICE_JOB: sqlServiceJob,
  SQL_SERVICE_JOB_ARRAY: [sqlServiceJob],
  // enums
  MERCHANDISE_GROUP: merchandiseGroup,
  MERCHANDISE_GROUP_ARRAY: [merchandiseGroup],
  PART_SUB_TYPE: partSubType,
  PART_SUB_TYPE_ARRAY: [partSubType],
  PART_TYPE: partType,
  PART_TYPE_ARRAY: [partType],
  SERVICE_TYPE: serviceType,
  SERVICE_TYPE_ARRAY: [serviceType],
  USER_ROLE: userRole,
  USER_ROLE_ARRAY: [userRole],
}

export default Schemas
